import { Button, Input, message, notification, Radio, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ErrorItem,
    InputNumberItem,
    DatePickerItem,
    AutoCompleteItem,
    dineroDisabledMask,
} from "../../../../Components/Items";
import dayjs from "dayjs";

const { Option } = Select

class AgregarRegistro extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        objetoCarreras: null,
        todasCarreras: [],
        optionEquipos: [],
        todasEquipos: []
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ loading: true })
            axios
                .post(
                    "registroCarrera/datosParaRegistro",
                    { empresaId: this.props.empresaId },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false })
                    if (res.data.success === 2) {
                        this.setState({
                            loading: false,
                            todasCarreras: res.data.carreras,
                            objetoCarreras: res.data.carreras.map(valueCarrera => (
                                <Option value={valueCarrera._id} key={valueCarrera._id}>
                                    {valueCarrera.nombre + ' - ' + valueCarrera.distancia + ' km ' + dineroDisabledMask(valueCarrera.precio)}
                                </Option>
                            )),
                            todasEquipos: res.data.equipos,
                            optionEquipos: res.data.equipos.map(valueEquipo => {
                                return {
                                    label: valueEquipo.nombre,
                                    value: valueEquipo.nombre
                                }
                            }),
                        })
                    } else {
                        message.error("Error no se encontro informacion para el registro");
                    }
                });
        }

    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "registrosCarrera/agregarRegistro",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    notification.success({
                        message: "Referencia: " + res.data.folio,
                        description: "Registro exitoso con referencia: " + res.data.folio
                    })
                    message.success("Registro agregado exitosamente");
                    this.cerrarModalAgregarRegistro();
                } else if (res.data.success === 1) {
                    message.error("No se pudo agregar el registro");
                } else {
                    message.error("Sucedió un error y no se pudo agregar el registro");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModalAgregarRegistro() {
        this.setState({ visible: false });
        this.props.cerrarModalAgregarRegistro();
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

    render() {
        return (
            <ModalItem
                title="Agregar Registro"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalAgregarRegistro.bind(this)}
                width={800}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="modalAgregarRegistro"
                    layout='vertical'
                    bottom={
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            loading={this.state.loading}
                        >
                            Registrar
                        </Button>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label="Nombre Completo"
                        required
                        name="nombre"
                    >
                        <Input
                            placeholder="Nombre completo"
                        />
                    </FormItem>

                    <FormItem
                        label="Fecha de Nacimiento"
                        required
                        name="fechaNacimiento"
                    >
                        <DatePickerItem
                            disabledDate={(current) => {
                                return current && (current < dayjs('1900-01-01') || current > dayjs());
                            }}
                        />
                    </FormItem>

                    <FormItem
                        label="Correo Electrónico"
                        required
                        email={true}
                        name="correo"
                    >
                        <Input
                            placeholder="correo@ejemplo.com"
                        />
                    </FormItem>


                    <FormItem
                        label="Teléfono"
                        required
                        name="telefono"
                    >
                        <InputNumberItem placeholder="Teléfono" celular={true} />
                    </FormItem>


                    <FormItem
                        label="Equipo"
                        name="equipo"
                    >
                        <AutoCompleteItem
                            options={this.state.optionEquipos}
                            virtual={false}
                            placeholder="Nombre del equipo"
                            filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                        />
                    </FormItem>

                    <FormItem label="Rama" name="rama" required>
                        <Radio.Group
                        >
                            <Radio value={1}>Varonil</Radio>
                            <Radio value={2}>Femenil</Radio>
                        </Radio.Group>
                    </FormItem>

                    <FormItem
                        label="Carrera"
                        required
                        name="carreraId"
                    >
                        <Select
                            placeholder="Selecciona una carrera"
                        >
                            {this.state.objetoCarreras}
                        </Select>
                    </FormItem>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(AgregarRegistro);
